<ng-container
  *ngIf="{
    request: searchProductRequest$ | async,
    showProducts: showProducts$ | async,
  } as content"
>
  <div #container class="js-container-search-product container-search-product">
    <form [formGroup]="form" (submit)="submit()">
      <div class="form-group m-0">
        <label class="m-0">
          <span class="label-content">Search a Product</span>

          <div class="container-input">
            <input
              class="form-control m-0"
              type="text"
              name="search"
              maxlength="255"
              placeholder="Search by product, category or code"
              formControlName="search"
            />

            <button class="btn btn-primary" [disabled]="content.request?.isLoading">
              @if (content.request?.isLoading) {
                <local-loader [invertedColor]="true"></local-loader>
              } @else {
                <span class="material-symbols-outlined d-flex m-r-4"> search </span>
                Search
              }
            </button>

            @if (content.showProducts) {
              <div class="container-list">
                <ul class="product-list">
                  @if (content.request?.products?.length) {
                    <li
                      *ngFor="let product of content.request?.products"
                      (click)="selectProduct(product)"
                      (keyup.enter)="selectProduct(product)"
                      tabindex="0"
                    >
                      <product-item [product]="product"></product-item>
                    </li>
                  } @else {
                    <li class="no-results">No results found</li>
                  }
                </ul>
              </div>
            }
          </div>

          <cx-form-errors [control]="form.get('search')"></cx-form-errors>
        </label>
      </div>
    </form>
  </div>
</ng-container>
